(function () {
  'use strict';

  var root = document.documentElement;
  var SEARCH_OPEN_CLASS = 'ovc-search-open';
  var SEARCH_STYLE_ID = 'ovc-mobile-search-fallback-styles';

  function loadCss(id, href) {
    if (!href || document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'screen';
    document.head.appendChild(link);
  }

  function addSearchFallbackStyles() {
    if (document.getElementById(SEARCH_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = SEARCH_STYLE_ID;
    style.textContent = [
      '@media only screen and (max-width: 760px) {',
      '  html.' + SEARCH_OPEN_CLASS + ' #root .shopify-section-header #search {',
      '    display: block !important;',
      '    visibility: visible !important;',
      '    opacity: 1 !important;',
      '    pointer-events: auto !important;',
      '    position: absolute !important;',
      '    left: 0 !important;',
      '    right: 0 !important;',
      '    top: 100% !important;',
      '    width: 100% !important;',
      '    max-width: none !important;',
      '    z-index: 324 !important;',
      '  }',
      '  html.' + SEARCH_OPEN_CLASS + ' #root .shopify-section-header #search fieldset,',
      '  html.' + SEARCH_OPEN_CLASS + ' #root .shopify-section-header #search > p {',
      '    display: block !important;',
      '    visibility: visible !important;',
      '    opacity: 1 !important;',
      '    pointer-events: auto !important;',
      '  }',
      '  html.' + SEARCH_OPEN_CLASS + ' #root .shopify-section-header #search input[type="search"] {',
      '    display: block !important;',
      '    visibility: visible !important;',
      '    opacity: 1 !important;',
      '    pointer-events: auto !important;',
      '    width: 100% !important;',
      '  }',
      '}',
      '@media only screen and (min-width: 761px) {',
      '  html.' + SEARCH_OPEN_CLASS + ' #root .shopify-section-header #search {',
      '    visibility: visible !important;',
      '    opacity: 1 !important;',
      '    pointer-events: auto !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function getMenu() {
    return document.getElementById('nav');
  }

  function getSearch() {
    return document.getElementById('search');
  }

  function getSearchControls() {
    return document.querySelectorAll(
      '.shopify-section-header a[aria-controls="search"], ' +
      '.shopify-section-header button[aria-controls="search"]'
    );
  }

  function setControlState(selector, expanded) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (control) {
      control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function ensureMenuClose(menu) {
    if (!menu || menu.querySelector('a.close-nav')) return;
    var close = document.createElement('a');
    close.href = '#';
    close.className = 'close close-nav ovc-header-fallback-close';
    close.textContent = 'Close';
    menu.appendChild(close);
  }

  function setMenuOpen(open) {
    var menu = getMenu();
    if (!menu) return;

    loadCss('css-menu', window.filepaths && window.filepaths.async_menu_css);
    root.classList.add('has-nav');
    ensureMenuClose(menu);

    if (open) {
      closeSearch();
      root.classList.add('m2a');
      root.classList.remove('nav-hover', 'user-form-active');
      Array.prototype.forEach.call(menu.querySelectorAll('a'), function (link) {
        link.removeAttribute('tabindex');
      });
    } else {
      root.classList.remove('m2a', 'nav-hover');
    }

    setControlState('.shopify-section-header [aria-controls="nav"]', open);
  }

  function searchPageUrl() {
    return '/search';
  }

  function makeSearchUsable(search) {
    var fieldset = search.querySelector('fieldset');
    var input = search.querySelector('input[type="search"]');

    search.removeAttribute('hidden');
    search.removeAttribute('aria-hidden');
    search.setAttribute('role', search.getAttribute('role') || 'search');

    if (!search.getAttribute('action')) search.setAttribute('action', searchPageUrl());
    if (!search.getAttribute('method')) search.setAttribute('method', 'get');

    if (fieldset) {
      fieldset.removeAttribute('hidden');
      fieldset.removeAttribute('aria-hidden');
      Array.prototype.forEach.call(
        fieldset.querySelectorAll('a, input, button, select, textarea, [role="button"]'),
        function (element) {
          element.removeAttribute('tabindex');
          element.removeAttribute('aria-hidden');
        }
      );
    }

    if (input) {
      input.removeAttribute('tabindex');
      input.removeAttribute('aria-hidden');
      if (!input.name) input.name = 'q';
      input.setAttribute('autocomplete', 'off');
    }

    return input;
  }

  function openSearch() {
    var search = getSearch();
    if (!search) {
      window.location.assign(searchPageUrl());
      return;
    }

    addSearchFallbackStyles();
    loadCss('css-search', window.filepaths && window.filepaths.async_search_css);

    root.classList.remove(
      'm2a',
      'nav-hover',
      'user-form-active',
      'f8fl-open'
    );
    root.classList.add('search-compact-active', SEARCH_OPEN_CLASS);

    search.classList.remove('hidden');
    var input = makeSearchUsable(search);

    Array.prototype.forEach.call(getSearchControls(), function (control) {
      control.setAttribute('aria-expanded', 'true');
    });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (input) {
          try {
            input.focus({ preventScroll: true });
          } catch (error) {
            input.focus();
          }
        }
      });
    });

    window.setTimeout(function () {
      var currentSearch = getSearch();
      if (!currentSearch) return;
      var rect = currentSearch.getBoundingClientRect();
      var styles = window.getComputedStyle(currentSearch);
      var hidden = styles.display === 'none' || styles.visibility === 'hidden' || rect.height < 1;
      if (hidden) {
        currentSearch.style.setProperty('display', 'block', 'important');
        currentSearch.style.setProperty('visibility', 'visible', 'important');
        currentSearch.style.setProperty('opacity', '1', 'important');
        currentSearch.style.setProperty('pointer-events', 'auto', 'important');
        if (input) input.focus();
      }
    }, 250);
  }

  function closeSearch() {
    var search = getSearch();

    root.classList.remove(
      'search-compact-active',
      SEARCH_OPEN_CLASS,
      'search-full',
      'search-full-mode',
      'search-focus'
    );

    if (search) {
      search.classList.remove('full', 'processing');
      search.style.removeProperty('display');
      search.style.removeProperty('visibility');
      search.style.removeProperty('opacity');
      search.style.removeProperty('pointer-events');
    }

    Array.prototype.forEach.call(getSearchControls(), function (control) {
      control.setAttribute('aria-expanded', 'false');
    });
  }

  function searchIsOpen() {
    return root.classList.contains(SEARCH_OPEN_CLASS) ||
      root.classList.contains('search-compact-active');
  }

  function handleSearchControl(event, control) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (searchIsOpen()) {
      closeSearch();
    } else {
      openSearch();
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var searchControl = target.closest(
        '.shopify-section-header a[aria-controls="search"], ' +
        '.shopify-section-header button[aria-controls="search"]'
      );
      if (searchControl && !searchControl.closest('#search')) {
        handleSearchControl(event, searchControl);
        return;
      }

      var menuControl = target.closest('.shopify-section-header [aria-controls="nav"]');
      if (menuControl && !menuControl.closest('#nav')) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        setMenuOpen(!root.classList.contains('m2a'));
        return;
      }

      if (target.closest('#nav a.close-nav')) {
        event.preventDefault();
        setMenuOpen(false);
        return;
      }

      if (target.closest('#search .search-back, #search > a.toggle')) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        closeSearch();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (root.classList.contains('m2a')) setMenuOpen(false);
      if (searchIsOpen()) closeSearch();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'search') return;

    var input = form.querySelector('input[type="search"]');
    if (!form.getAttribute('action')) form.setAttribute('action', searchPageUrl());
    if (input && !input.name) input.name = 'q';
  });

  addSearchFallbackStyles();
})();
